import React, { useState, useEffect } from "react";
import {
  AccountingHeader,
  InvoiceButton,
} from "../accounting/styles/InvoiceStyles";
import { HeaderMain } from "../customer/styles/HeaderStyles";
import search from "../../../assets/images/search.svg";
// import SearchMain from "../shared/SearchMain";
import NewUserPopup from "./NewUserPopup";
import {
  SearchButton,
  SearchClean,
  SearchInputMain,
} from "../shared/styles/SearchStyle";
import { IconButton } from "@mui/material";
import { GetComePermissions } from "../../../services/admin/agents";

const Header = ({
  SearchInputValue = "",
  setSearchInputValue = () => {},
  UsersData = "",
  SetUsersData = () => {},
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [SubmitedValue, setSubmitedValue] = useState("");

  useEffect(() => {
    const retuenvalue = {
      id: SubmitedValue?.slug,
      name: SubmitedValue?.name,
      email: SubmitedValue?.email,
      Permissions: GetComePermissions(SubmitedValue?.permissions),
    };
    if (SubmitedValue) {
      SetUsersData([retuenvalue, ...UsersData]);
    }
  }, [SubmitedValue]);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  //  ================= Search  =================

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleButtonClick = () => {
    setSearchInputValue(searchText);
  };
  const CleanHandleClick = () => {
    setSearchInputValue("");
    setSearchText("");
  };
  //  ================= End Search  =================

  return (
    <>
      <AccountingHeader>
        <HeaderMain>
          {/* <SearchMain placeholder="Search for  name, email..." /> */}
          <SearchInputMain>
            <img src={search} alt="search" />
            <input
              type="text"
              placeholder="Search for  name, email..."
              value={searchText}
              onChange={handleInputChange}
            />
            {searchText && (
              <IconButton onClick={handleButtonClick}>
                <SearchButton />
              </IconButton>
            )}
            {searchText && (
              <IconButton onClick={CleanHandleClick}>
                <SearchClean />
              </IconButton>
            )}
          </SearchInputMain>
        </HeaderMain>
        <InvoiceButton onClick={handleOpenDialog}>Add New User</InvoiceButton>
        <NewUserPopup
          open={openDialog}
          handleClose={handleCloseDialog}
          setSubmitedValue={setSubmitedValue}
        />
      </AccountingHeader>
    </>
  );
};

export default Header;
